export const getIndexForExpandedNode = (nestedNodeId, expandedNodes) => {
  for (let i = 0; i < expandedNodes.length; i += 1) {
    if (expandedNodes[i]['nestedNodeID'] === nestedNodeId) {
      return i;
    }
  }
  return -1;
};

export const expandedNodesHasId = (nestedNodeId, expandedNodes) => {
  return getIndexForExpandedNode(nestedNodeId, expandedNodes) >= 0;
};

const groupNodeFromNestedNodeID = (nestedNodeID) => {
  const stringPath = nestedNodeID.split('_');
  return stringPath.reverse();
};

export const convertExpandedNodesToGroupedNodeState = (clientState) => {
  if (!clientState.expandedNodes || clientState.expandedNodes.length === 0) {
    return {};
  }

  const groupedNodeState = {};
  const nodeDepths = {};

  if (clientState.columnState && clientState.columnState.length > 0) {
    clientState.columnState.forEach((col) => {
      if (col.rowGroup) {
        nodeDepths[col.colId] = col.rowGroupIndex;
      }
    });
  }

  clientState.expandedNodes.forEach((ex) => {
    const colId = ex.field;

    if (colId === undefined) {
      console.warn('Undefined colId encountered:', ex);
      return;
    }

    let convertedNode = null;
    if (nodeDepths[colId] !== undefined && nodeDepths[colId] === 0) {
      convertedNode = [ex.nestedNodeID];
    } else {
      convertedNode = groupNodeFromNestedNodeID(ex.nestedNodeID);
    }

    if (groupedNodeState[colId]) {
      groupedNodeState[colId].expandedNodes.push(convertedNode);
    } else {
      groupedNodeState[colId] = {
        defaultExpanded: false,
        expandedNodes: [convertedNode],
        collapsedNodes: [],
      };
    }
  });

  return groupedNodeState;
};

export const calcNestedNodeId = (node, id) => {
  if (node.level > 0) {
    return calcNestedNodeId(node.parent, id + '_' + node.parent.key);
  } else {
    return id;
  }
};

export const areArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};
